import './Contacto.css';

const info = [
  { icon: '🏢', label: 'Razón Social', valor: 'MECAPISCO S.A.C.' },
  { icon: '🪪', label: 'RUC', valor: '20605931775' },
  { icon: '📍', label: 'Dirección Fiscal', valor: 'Av. Garcilazo de la Vega N° 197, Pisco – Ica' },
  { icon: '📞', label: 'Teléfono', valor: '988 978 485', href: 'tel:988978485' },
  { icon: '✉️', label: 'Correo', valor: 'jbarbaran@mecapisco.com.pe', href: 'mailto:jbarbaran@mecapisco.com.pe' },
];

export default function Contacto() {
  return (
    <section id="contacto" className="contacto">
      <div className="container contacto__inner">
        <div className="contacto__info">
          <h2 className="section-title" style={{ textAlign: 'left' }}>
            Información Corporativa
          </h2>
          <div className="section-divider" style={{ margin: '12px 0 36px' }} />
          <ul className="contacto__list">
            {info.map((item) => (
              <li key={item.label} className="contacto__item">
                <span className="contacto__icon">{item.icon}</span>
                <div>
                  <span className="contacto__label">{item.label}</span>
                  {item.href ? (
                    <a href={item.href} className="contacto__valor contacto__valor--link">
                      {item.valor}
                    </a>
                  ) : (
                    <span className="contacto__valor">{item.valor}</span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="contacto__cobertura">
          <h3 className="contacto__cob-titulo">Cobertura Nacional</h3>
          <p className="contacto__cob-sub">Llegamos a todo el Perú</p>
          <div className="contacto__map-placeholder">
            <span>🗺️</span>
            <p>Pisco · Ica · Lima · Callao<br />y todo el territorio nacional</p>
          </div>
        </div>
      </div>
    </section>
  );
}
